var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StudyCalendar',{staticClass:"member-calendar",on:{"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }